@if (initialized && interactionData && interactionData.type) {

  @if (interactionData.interaction?.form) {
    <app-form
      [form]="interactionData.interaction?.form"
      (onFormGroupStatusChange)="handleFormGroupStatusChange($event)"
      (onFormGroupValueChange)="handleFormGroupValueChange($event)"
    ></app-form>
  } @else {
    <app-form
      [form]="interactionData.type?.form"
      (onFormGroupStatusChange)="handleFormGroupStatusChange($event)"
      (onFormGroupValueChange)="handleFormGroupValueChange($event)"
    ></app-form>

  }



  @if (interactionData.type.allowDocumentUpload) {
    <core-upload
      [busy]="busy"
      (onDocumentUploaded)="handleFileUpload($event)"
      (onSelect)="handleFileSelect($event)"
      (onClear)="handleFileClear()"
    ></core-upload>
  }

  @if (interactionData.interaction && interactionData.interaction?.documents) {
    <div class="grid mt-4">
      @for (doc of interactionData.interaction?.documents; track doc.id) {
        <section class="xl:col-3 md:col-6 col-12">
          <div class="card p-2 shadow-1">
            <div class="flex justify-content-between p-3 pt-2 border-bottom-1 border-200 m-2 align-items-center">
              <h5 class="pdf-card-title text-sm m-0 mr-2">{{ doc.name }}</h5>
              <div class="flex gap-3">
                <i
                  class="pi pi-window-maximize cursor-pointer"
                  (click)="onShowDocument(doc)"
                ></i>
                @if (doc.id) {
                  <i
                    class="pi pi-trash text-red-600 cursor-pointer"
                    (click)="onDeleteDocument($event,doc.id)"
                  ></i>
                }
              </div>
            </div>
            <div class="p-1 h-12rem overflow-hidden">
              <app-pdf-view
                class="w-full h-full"
                [objectService]="interactionApiService"
                [documentId]="doc.id"
                [addedId]="interactionData.interaction.id"
              ></app-pdf-view>
            </div>
          </div>
        </section>
      }
    </div>
  }

}


<p-dialog
  [header]="selectedDocument?.name"
  [(visible)]="visible"
  [style]="{width: '65rem', height: '75vh'}"
  [modal]="true"
  (onHide)="selectedDocument = undefined">
  @if (selectedDocument && interactionData && interactionData.interaction) {
    <app-pdf-view [objectService]="interactionApiService"
                  [documentId]="selectedDocument.id"
                  [addedId]="interactionData.interaction.id"
                  (handleNewWindowOpened)="handleWindowOpened($event)"
                  class="w-full h-full"></app-pdf-view>
  }

</p-dialog>

<p-confirmDialog></p-confirmDialog>
